const BaseURL = {
  BASE_URL: `${process.env.REACT_APP_API_URL}`,
};

export const API_CONSTANTS = {
  BASE_TOKEN: `${process.env.REACT_APP_API_KEY}`,
  LOGIN_DATA: `${BaseURL.BASE_URL}/api/v1/auth/login`,
  FORGOT_PASSWORD: `${BaseURL.BASE_URL}/api/v1/user/forgot-password`,
  CHANGE_PASSWORD:  `${BaseURL.BASE_URL}/api/v1/user/change-password`,
  CHECK_PASSWORD_TOKEN: `${BaseURL.BASE_URL}/api/v1/user/check-password-token`,
  RESET_PASSWORD: `${BaseURL.BASE_URL}/api/v1/user/reset-password`,
  GET_TERRITORY: `${BaseURL.BASE_URL}/api/v1/user/get-territory`,
  ADD_DEALER: `${BaseURL.BASE_URL}/api/v1/user/add-dealer`,
  APPROVE_DEALER: `${BaseURL.BASE_URL}/api/v1/user/approve-dealer`,
  SAVE_FOR_APPROVE_DEALER: `${BaseURL.BASE_URL}/api/v1/user/save-for-approval-dealer`,
  REJECT_DEALER: `${BaseURL.BASE_URL}/api/v1/user/reject-dealer`,
  MODIFY_DEALER: `${BaseURL.BASE_URL}/api/v1/user/modify-dealer`,
  GET_DEALER_BY_ID: `${BaseURL.BASE_URL}/api/v1/user/get-dealer-by-id`,
  GET_DEALER: `${BaseURL.BASE_URL}/api/v1/user/get-dealer`,
  EDIT_DEALER: `${BaseURL.BASE_URL}/api/v1/user/edit-dealer`,
  DELETE_DEALER: `${BaseURL.BASE_URL}/api/v1/user/delete-dealer`,
  GET_STATE: `${BaseURL.BASE_URL}/api/v1/user/get-state`,
  // GET_STATE_DISTRICT: `${BaseURL.BASE_URL}/api/v1/retail-branding/get-state-district`,
  GET_STATE_DISTRICT: `${BaseURL.BASE_URL}/api/v1/user/get-state-district`,
  GET_STATE_CITY: `${BaseURL.BASE_URL}/api/v1/user/get-state-city`,
  SEND_OTP_DEALER: `${BaseURL.BASE_URL}/api/v1/user/send-otp-dealer`,
  VERIFY_OTP_DEALER: `${BaseURL.BASE_URL}/api/v1/user/verify-otp-dealer`,
  ADD_DEALER_OWNER: `${BaseURL.BASE_URL}/api/v1/user/add-dealer-owner`,
  EDIT_DEALER_OWNER: `${BaseURL.BASE_URL}/api/v1/user/edit-dealer-owner`,
  DEALER_DOCUMENT_UPLOAD: `${BaseURL.BASE_URL}/api/v1/user/upload-dealer-document`,
  EDit_COMPETITION: `${BaseURL.BASE_URL}/api/v1/user/edit-competition`,
  EDIT_COMMITMENT: `${BaseURL.BASE_URL}/api/v1/user/edit-comitment`,
  GET_PRODUCTS: `${BaseURL.BASE_URL}/api/v1/user/get-product`,
  ADD_COMMITMENT: `${BaseURL.BASE_URL}/api/v1/user/add-comitment`,
  GET_COMMITMENT: `${BaseURL.BASE_URL}/api/v1/user/get-comitment`,
  GET_COMPETITION: `${BaseURL.BASE_URL}/api/v1/user/get-competition`,
  ADD_COMPETITION: `${BaseURL.BASE_URL}/api/v1/user/add-competition`,
  KYC_DUE: `${BaseURL.BASE_URL}/api/v1/user/yearly-kyc`,
  UPDATE_CREDIT_LIMIT: `${BaseURL.BASE_URL}/api/v1/user/update-credit-limit`,
  DELETE_COMITMENT: `${BaseURL.BASE_URL}/api/v1/user/delete-comitment`,
  DELETE_COMPETITION: `${BaseURL.BASE_URL}/api/v1/user/delete-competition`,
  DELETE_DEALER_OWNER: `${BaseURL.BASE_URL}/api/v1/user/delete-dealer-owner`,

  GET_STATE_DISTRICT_CITY: `${BaseURL.BASE_URL}/api/v1/user/state-district-city`,

  GET_USER_INFO: `${BaseURL.BASE_URL}/api/v1/user/get-user-info`,
  GET_STATE_HEAD_LIST: `${BaseURL.BASE_URL}/api/v1/user/get-state-head-list`,
  GET_NATIONAL_HEAD_LIST: `${BaseURL.BASE_URL}/api/v1/user/get-national-head-list`,
  GET_BUSINESS_HEAD_LIST: `${BaseURL.BASE_URL}/api/v1/user/get-business-head-list`,
  GET_STATE_OF_STATE_HEAD: `${BaseURL.BASE_URL}/api/v1/user/get-state-of-state-head`,
  GET_STATE_HEAD_TM: `${BaseURL.BASE_URL}/api/v1/user/get-state-head-tm`,
  GET_PENDING_WITH_LIST_FILTER: `${BaseURL.BASE_URL}/api/v1/user/pending-with-list-filter`,

  // Count API
  GET_MEETING_COUNT: `${BaseURL.BASE_URL}/api/v1/user/get-meeting-count`,
  GET_DEALER_COUNT: `${BaseURL.BASE_URL}/api/v1/user/get-dealer-count`,
  GET_ORDER_SUMMARY_COUNT: `${BaseURL.BASE_URL}/api/v1/user/order-summary-count`,
  GET_DEALER_ENGAGEMENT: `${BaseURL.BASE_URL}/api/v1/user/get-dealer-engagement`,
  GET_DEALER_ACTIVE_INACTIVE_COUNT: `${BaseURL.BASE_URL}/api/v1/user/dealer-active-invative-count`,

  // Table API
  GET_MEETING_WITH_STATUS: `${BaseURL.BASE_URL}/api/v1/user/get-meeting-with-status`,
  GET_DEALER_WITH_STATUS: `${BaseURL.BASE_URL}/api/v1/user/get-dealer-with-status`,
  GET_ORDER_SUMMARY_COUNT_WITH_STATUS: `${BaseURL.BASE_URL}/api/v1/user/order-summary-count-with-status`,
  GET_DEALER_ENGAGEMENT_WITH_STATUS: `${BaseURL.BASE_URL}/api/v1/user/get-dealer-engagement-with-status`,
  GET_DEALER_ACTIVE_INACTIVE_WITH_STATUS: `${BaseURL.BASE_URL}/api/v1/user/dealer-active-invative-with-status`,

  // Hierarchy API
  GET_MEETING_COUNT_HIERARCHY: `${BaseURL.BASE_URL}/api/v1/user/get-meeting-count-hierarchy-wise`,
  GET_DEALER_COUNT_HIERARCHY: `${BaseURL.BASE_URL}/api/v1/user/get-dealer-count-hierarchy-wise`,
  GET_ORDER_SUMMARY_COUNT_HIERARCHY: `${BaseURL.BASE_URL}/api/v1/user/order-summary-count-hierarchy-wise`,
  GET_DEALER_ENGAGEMENT_COUNT_HIERARCHY: `${BaseURL.BASE_URL}/api/v1/user/get-dealer-engagement-hierarchy-wise`,
  GET_DEALER_ACTIVE_INACTIVE_COUNT_HIERARCHY: `${BaseURL.BASE_URL}/api/v1/user/dealer-active-invative-hierarchy-wise`,

  // Meeting Activity - Dealer Meeting History
  DEALER_MEETING_HISTORY: `${BaseURL.BASE_URL}/api/v1/user/get-dealer-meeting-history`,

  // Approve app print / Generate API
  GENERATE_PDF: `${BaseURL.BASE_URL}/api/v1/user/generate-pdf`,

  // Performance API
  GET_PERFORMANCE_INSIGHT: `${BaseURL.BASE_URL}/api/v1/goal/performance-insight`,
  GET_GOAL: `${BaseURL.BASE_URL}/api/v1/goal/get-all`,
  UPDATE_GOAL: `${BaseURL.BASE_URL}/api/v1/goal/update`,
  GET_SUCCESSORS: `${BaseURL.BASE_URL}/api/v1/goal/get-successors`,

  // admin apis

  // Manage Dealer
  ACTIVE_INACTIVE_DEALER: `${BaseURL.BASE_URL}/api/v1/admin/active-inactive-dealer`,

  ASSIGN_DEALER_CODE: `${BaseURL.BASE_URL}/api/v1/admin/assign-dealer-code`,
  RISK_MEASURE_TAG: `${BaseURL.BASE_URL}/api/v1/admin/set-risk-measure-tag`,
  CASH_CREDIT_RATIO: `${BaseURL.BASE_URL}/api/v1/admin/set-cash-credit-ratio`,
  ADD_USER: `${BaseURL.BASE_URL}/api/v1/admin/add-user`,
  UPDATE_USER: `${BaseURL.BASE_URL}/api/v1/admin/update-user`,
  GET_LIST_USER: `${BaseURL.BASE_URL}/api/v1/admin/list-users`,
  ACTIVE_INACTIVE_USER: `${BaseURL.BASE_URL}/api/v1/admin/active-inactive-user`,
  GET_DEALER_SAP_DATA: `${BaseURL.BASE_URL}/api/v1/admin/get-dealer-sap-data`,

  // Change TM
  GET_TERRITORY_TM: `${BaseURL.BASE_URL}/api/v1/admin/get-territory-tm`,
  ASSIGN_TERRITORY: `${BaseURL.BASE_URL}/api/v1/admin/assign-territory`,

  // Change Manager
  GET_MANAGER: `${BaseURL.BASE_URL}/api/v1/admin/get-manager`,
  CHANGE_MANAGER: `${BaseURL.BASE_URL}/api/v1/admin/change-manager`,

  // Product List
  GET_LIST_PRODUCTS: `${BaseURL.BASE_URL}/api/v1/admin/list-products`,
  ADD_PRODUCT: `${BaseURL.BASE_URL}/api/v1/admin/add-product`,
  UPDATE_PRODUCT: `${BaseURL.BASE_URL}/api/v1/admin/update-product`,
  DELETE_PRODUCT: `${BaseURL.BASE_URL}/api/v1/admin/delete-product`,
  GET_LIST_PRODUCT_SKUS: `${BaseURL.BASE_URL}/api/v1/admin/list-product-skus`,
  ADD_PRODUCT_SKU: `${BaseURL.BASE_URL}/api/v1/admin/add-product-sku`,
  UPDATE_PRODUCT_SKU: `${BaseURL.BASE_URL}/api/v1/admin/update-product-sku`,

  // Holidays
  GET_HOLIDAYS: `${BaseURL.BASE_URL}/api/v1/admin/get-holiday`,
  ADD_HOLIDAY: `${BaseURL.BASE_URL}/api/v1/admin/add-holiday`,
  UPDATE_HOLIDAY: `${BaseURL.BASE_URL}/api/v1/admin/update-holiday`,
  DELETE_HOLIDAY: `${BaseURL.BASE_URL}/api/v1/admin/delete-holiday`,

  // Login Report
  USER_ACTIVE_INACTIVE_LOGIN_COUNT: `${BaseURL.BASE_URL}/api/v1/user/user-active-inactive-login-count`,
  USER_ACTIVE_INACTIVE_LIST_DATE_WISE: `${BaseURL.BASE_URL}/api/v1/user/active-inactive-user-list-date-wise`,
  USER_LOGIN_HISTORY_MONTH_WISE: `${BaseURL.BASE_URL}/api/v1/user/user-login-history-month-wise`,
  USER_LOGIN_HISTORY_DATE_WISE: `${BaseURL.BASE_URL}/api/v1/user/user-login-history-date-wise`,
  USER_LOGIN_REPORT_DATE_WISE: `${BaseURL.BASE_URL}/api/v1/user/user-login-report-month-wise`,

  // Manage Territory API
  ADD_TERRITORY: `${BaseURL.BASE_URL}/api/v1/admin/add-territory`,
  GET_ALL_TERRITORIES: `${BaseURL.BASE_URL}/api/v1/admin/get-territories`,

  // Survey API
  ADD_SURVEY: `${BaseURL.BASE_URL}/api/v1/user/add-survey`,
  GENERATE_SURVEY_REPORT: `${BaseURL.BASE_URL}/api/v1/user/generate-survey-forms-report`,

  // User Travel Details
  PUNCH_IN: `${BaseURL.BASE_URL}/api/v1/user/add-punch-in`,
  PUNCH_OUT: `${BaseURL.BASE_URL}/api/v1/user/add-punch-out`,
  GET_PUNCHING_DATA: `${BaseURL.BASE_URL}/api/v1/user/get-punch-in-out-data`,

  // CNF User
  CNF_GET_ORDERS: `${BaseURL.BASE_URL}/api/v1/user/cnf/get-orders`,
  CNF_GET_ORDER_COUNT: `${BaseURL.BASE_URL}/api/v1/user/cnf/get-open-fulfilled-order-count`,
  CNF_ADD_INVOICE: `${BaseURL.BASE_URL}/api/v1/user/cnf/add-invoice`,
  CNF_UPDATE_INVOICE: `${BaseURL.BASE_URL}/api/v1/user/cnf/update-invoice`,
  CNF_BOOK_ORDER: `${BaseURL.BASE_URL}/api/v1/user/cnf/order-book`,
  CNF_BOOK_MULTIPLE_ORDER: `${BaseURL.BASE_URL}/api/v1/user/cnf/multiple-order-book`,
  CNF_TERRITORY_MANAGERS: `${BaseURL.BASE_URL}/api/v1/user/cnf/get-territory_managers`,
  CNF_CONFIRM_CHEQUE: `${BaseURL.BASE_URL}/api/v1/user/cnf/confirm-cheque`,

  GET_CUSTOMER_DATA_FROM_SAP: `${BaseURL.BASE_URL}/api/v1/user/sap/get-customer-data`,
  GENERATE_PDF_WITH_SAP_DATA: `${BaseURL.BASE_URL}/api/v1/user/sap/generate-pdf`,

  GET_CREDIT_OUTSTANDING_BALANCE: `${BaseURL.BASE_URL}/api/v1/user/sap/credit-outstading-balance`,
  GET_AGEING_REPORT: `${BaseURL.BASE_URL}/api/v1/user/sap/aging-report`,
};

export const API_METHODS = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE',
  PUT: 'PUT',
};
